/**
 * Created by vaibhav on 31/3/18
 */
import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import Link from 'gatsby-link';
import Img from 'gatsby-image';
import Content, { HTMLContent } from '../components/Content';

export const AlbumPageTemplate = ({
  title,
  content,
  contentComponent,
  featuredImage,
}) => {
  const PageContent = contentComponent || Content;

  return (
    <div>
      <section className="hero is-primary is-bold">
        <div className="hero-body header-bgimage">
          <Img
            sizes={featuredImage.childImageSharp.sizes}
            imgStyle={{ objectPosition: 'center 20%' }}
            style={{
              background: `linear-gradient(to top, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.25)), linear-gradient(to bottom, rgba(0, 0, 0, 0.25), rgba(255, 255, 255, 0.75))`,
              backgroundSize: 'cover',
              color: '#fff',
              display: 'flex',
              height: '300px',
              height: '40vh',
              justifyContent: 'space-around',
              left: 0,
              position: 'absolute',
              top: 0,
              width: '100%',
              zIndex: -5,
            }}
          />
        </div>
      </section>
      <section className="body section is-paddingless album">
        <div className="container">
          <div className="section">
            <div className="columns">
              <div className="column is-12 is-offset-2 slide-up">
                <div className="content column is-4">
                  <PageContent className="content" content={content} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

AlbumPageTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  featuredImage: PropTypes.string,
  content: PropTypes.string,
  contentComponent: PropTypes.func,
};

const AlbumPage = ({ data }) => {
  const { markdownRemark: post } = data;

  return (
    <div>
      <Helmet>
        <title>{post.frontmatter.meta_title}</title>
        <meta name="description" content={post.frontmatter.meta_description} />
      </Helmet>
      <AlbumPageTemplate
        contentComponent={HTMLContent}
        title={post.frontmatter.title}
        featuredImage={post.frontmatter.featuredImage}
        content={post.html}
      />
    </div>
  );
};

AlbumPage.propTypes = {
  data: PropTypes.object.isRequired,
};

export default AlbumPage;

export const albumPageQuery = graphql`
  query AlbumPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
        title
        featuredImage {
          childImageSharp {
            sizes(maxWidth: 1368, quality: 90) {
              ...GatsbyImageSharpSizes
            }
          }
        }
        meta_title
        meta_description
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/album-page.js